import { TFunction } from 'i18next';
import { plurals } from 'utils/localization';

export const validateLength = (
    value: string,
    maxLength: number,
    t: TFunction
): string =>
    value.length <= maxLength
        ? undefined
        : plurals(t, 'general.maxLength', maxLength);
